<template>
  <div class="ai-order-form">
    <div class="ai-order-box">
      <!-- 加了 :disabled="loading" 整个表单禁用 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
        label-width="100px"
        class="demo-ruleForm"
        size="small"
        :disabled="loading"
      >
        <!-- AI 填单内容 大文本域 -->
        <el-form-item :label="$t('AIOrderForm.text')" prop="text">
          <el-input
            v-model="ruleForm.text"
            type="textarea"
            :rows="10"
            :placeholder="$t('AIOrderForm.placehsteps')"
            style="width: 100%"
          ></el-input>
        </el-form-item>

        <!-- 文件上传 -->
        <el-form-item :label="$t('AIOrderForm.upload')" prop="files">
          <div class="upload-wrapper" @contextmenu.prevent="showContextMenu">
          <el-upload
            ref="upload"
            :auto-upload="false"
            action=""
            :file-list="fileList"
            multiple
            :limit="9"
            drag
            accept=".jpg,.png,.jpeg,.pdf,.doc,.docx,.xls,.xlsx"
            class="upload-demo"
            :on-preview="handlePreview"
          >
            <!-- <el-button size="small" type="primary">
              {{ $t("AIOrderForm.dianjishangchuan") }}
            </el-button>
            <div slot="tip" class="el-upload__tip">
              {{ $t("AIOrderForm.zhichiduogewenjian") }}
            </div> -->

            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{ $t("AIOrderForm.tuozhuaiwenjian") }}<em>{{ $t("AIOrderForm.dianjishangchuan") }}</em></div>
            <div class="el-upload__text" style="margin-top:8px;font-size:12px;color:#909399;">{{ $t("AIOrderForm.ctrlvTip").split('Ctrl+V')[0] }}<kbd style="background:#f4f4f5;border:1px solid #dcdfe6;border-radius:3px;padding:1px 5px;">Ctrl+V</kbd>{{ $t("AIOrderForm.ctrlvTip").split('Ctrl+V')[1] }}</div>
            <div class="el-upload__tip" slot="tip"> {{ $t("AIOrderForm.zhichiduogewenjian") }}{{ $t("AIOrderForm.ctrlvSupport") }}</div>

          </el-upload>
          <!-- 自定义右键菜单 -->
          <div v-if="contextMenuVisible" class="context-menu" :style="{ top: contextMenuY + 'px', left: contextMenuX + 'px' }">
            <div class="context-menu-item" @click="triggerPaste">
              <i class="el-icon-document-copy"></i> 粘贴文件
            </div>
          </div>
          </div>
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item style="text-align: right">
          <el-button size="small" type="primary" @click="submitForm('ruleForm')" :loading="loading">
            {{ $t("AIOrderForm.submit") }}
          </el-button>
          <el-button size="small" @click="resetForm('ruleForm')">
            {{ $t("AIOrderForm.reset") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" title="文件预览" width="800px" append-to-body @close="closePreview">
      <img v-if="previewType === 'image'" :src="previewUrl" style="width:100%;" alt="预览图片" />
      <div v-else-if="previewType === 'other'" style="text-align:center;padding:40px 0;">
        <i class="el-icon-document" style="font-size:48px;color:#909399;"></i>
        <p style="margin-top:16px;color:#606266;">{{ previewFileName }}</p>
        <p style="color:#909399;font-size:13px;">该文件类型不支持在线预览</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { aiOrderSubmit } from "@/api/aiorder";
import { Loading } from 'element-ui'; // 引入全局loading

export default {
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      user_code: "",
      loading: false,
      ruleForm: {
        text: "",
      },
      fileList: [],
      loadingInstance: null,
      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      previewVisible: false,
      previewUrl: '',
      previewType: '',
      previewFileName: '',
      rules: {
        // 这里不再强制必填，交给提交时判断
        text: [],
      },
    };
  },
  mounted() {
    this.user_code = JSON.parse(window.localStorage.getItem("userInfo1")).user_code;
    window.addEventListener('paste', this.handlePaste);
    document.addEventListener('click', this.hideContextMenu);
  },
  beforeDestroy() {
    window.removeEventListener('paste', this.handlePaste);
    document.removeEventListener('click', this.hideContextMenu);
  },
  methods: {
    handlePreview(file) {
      const raw = file.raw || file;
      const name = file.name.toLowerCase();
      const imageExts = ['.jpg', '.jpeg', '.png'];
      const ext = '.' + name.split('.').pop();

      if (imageExts.includes(ext)) {
        this.previewType = 'image';
        this.previewUrl = URL.createObjectURL(raw);
        this.previewFileName = file.name;
        this.previewVisible = true;
      } else if (ext === '.pdf') {
        const url = URL.createObjectURL(raw);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } else {
        this.previewType = 'other';
        this.previewFileName = file.name;
        this.previewVisible = true;
      }
    },
    closePreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = '';
      }
      this.previewType = '';
      this.previewFileName = '';
    },
    showContextMenu(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      this.contextMenuX = event.clientX - rect.left;
      this.contextMenuY = event.clientY - rect.top;
      this.contextMenuVisible = true;
    },
    hideContextMenu() {
      this.contextMenuVisible = false;
    },
    async triggerPaste() {
      this.contextMenuVisible = false;
      try {
        const clipboardItems = await navigator.clipboard.read();
        let hasFile = false;
        for (const item of clipboardItems) {
          for (const type of item.types) {
            if (type.startsWith('image/') || type === 'application/octet-stream') {
              const blob = await item.getType(type);
              const file = new File([blob], `粘贴文件_${Date.now()}.${type.split('/')[1]}`, { type });
              this.addFileToUpload(file);
              hasFile = true;
            }
          }
        }
        if (!hasFile) {
          this.$message.info('未检测到可粘贴的文件，请尝试使用 Ctrl+V');
        }
      } catch (e) {
        this.$message.info('请使用 Ctrl+V 粘贴文件');
      }
    },
    addFileToUpload(file) {
      const allowedTypes = ['.jpg', '.png', '.jpeg', '.pdf', '.doc', '.docx', '.xls', '.xlsx'];
      const ext = '.' + file.name.split('.').pop().toLowerCase();
      if (!allowedTypes.includes(ext) && !file.type.startsWith('image/')) return;
      const exists = this.$refs.upload.uploadFiles.some(f => f.name === file.name && f.size === file.size);
      if (exists) return;
      if (this.$refs.upload.uploadFiles.length >= 9) {
        this.$message.warning('最多上传9个文件');
        return;
      }
      this.$refs.upload.uploadFiles.push({
        name: file.name,
        size: file.size,
        raw: file,
        status: 'ready',
        uid: Date.now() + Math.random()
      });
      this.$message.success(`已添加文件：${file.name}`);
    },
    handlePaste(event) {
      const items = event.clipboardData && event.clipboardData.items;
      if (!items) return;

      const files = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          const file = items[i].getAsFile();
          if (file) files.push(file);
        }
      }

      if (files.length > 0) {
        files.forEach(file => this.addFileToUpload(file));
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // ====================== 核心判断：文本 或 文件 至少一个 ======================
          const hasText = this.ruleForm.text && this.ruleForm.text.trim() !== '';
          const hasFile = this.$refs.upload.uploadFiles && this.$refs.upload.uploadFiles.length > 0;

          if (!hasText && !hasFile) {
            this.$message.warning('订单信息 和 上传文件 至少填写一个！');
            return;
          }
          // ========================================================================

          // 1. 开启禁用 + 按钮loading
          this.loading = true;

          // 2. 开启全局全屏loading
          this.loadingInstance = Loading.service({
            lock: true,
            text: "正在提交，请稍候...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          let formData = new FormData();
          formData.append('user_code', JSON.parse(window.localStorage.getItem("userInfo1")).user_code);
          formData.append('text', this.ruleForm.text);

          const files = this.$refs.upload.uploadFiles;
          if (files && files.length > 0) {
            files.forEach((item) => {
              formData.append('files[]', item.raw);
            });
          }

          aiOrderSubmit(formData).then((res) => {
            if (res.code == 1) {
              const warnings = (res.data && res.data.warnings) || [];
              if (warnings.length > 0) {
                // 有门牌号缺失等告警时，弹窗提醒用户去列表核对地址
                const html = warnings.map((w) => `<div style="margin:4px 0;color:#e6a23c;">⚠ ${w}</div>`).join('');
                this.$alert(html, this.$t('AIOrderForm.warningTitle'), {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('AIOrderForm.warningConfirm'),
                  type: 'warning',
                }).then(() => {
                  this.resetForm("ruleForm");
                  this.$router.push({ path: '/AIorder/list' });
                }).catch(() => {
                  this.resetForm("ruleForm");
                  this.$router.push({ path: '/AIorder/list' });
                });
              } else {
                this.$message.success(res.msg);
                this.resetForm("ruleForm");
                this.$router.push({ path: '/AIorder/list' });
              }
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.$message.error(err.msg || '提交失败');
          }).finally(() => {
            // 关闭所有loading
            this.loading = false;
            if (this.loadingInstance) {
              this.loadingInstance.close();
            }
          });
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.text = "";
      this.fileList = [];
      this.$refs.upload.clearFiles();
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-order-form {
  padding: 0 0;
  .upload-demo{
    width: 100%;
  }
  ::v-deep .el-upload{
    width: 100%;
  }
  ::v-deep .el-upload-dragger{
    width: 100% !important;
    height: 240px !important;
    .el-icon-upload{
      margin: 70px 0 16px !important;
    }
  }
  .upload-wrapper {
    position: relative;
  }
  ::v-deep .el-upload-list__item-name {
    cursor: pointer;
  }
  .context-menu {
    position: absolute;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
    z-index: 9999;
    min-width: 120px;
    .context-menu-item {
      padding: 8px 16px;
      cursor: pointer;
      font-size: 13px;
      color: #606266;
      &:hover {
        background: #f5f7fa;
        color: #409eff;
      }
    }
  }
  .ai-order-box {
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: 100%;

    .demo-ruleForm {
      width: 60%;

      ::v-deep .el-form-item {
        text-align: left;
      }

      ::v-deep .el-form--label-top .el-form-item__label {
        width: 100%;
      }
    }
  }
}
</style>